var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OrderListCommon',{attrs:{"status":_vm.status,"urlT":_vm.urlT},on:{"listt":_vm.listt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }